module.exports = __webpack_public_path__ + "img/pr-3.9d8cd3d3.png";